import { render } from "./add-limit.vue?vue&type=template&id=cd876410"
import script from "./add-limit.vue?vue&type=script&lang=js"
export * from "./add-limit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__